import { FC, PropsWithChildren } from "react";
import SvgEdit from "../icons/Edit";
import Icon from "../ui/Icon";
import styles from "./CarAssignmentCell.module.css";

interface Props {
  canEdit: boolean;
  onEdit: () => void;
}

const CarAssignmentCell: FC<PropsWithChildren<Props>> = ({ children, canEdit, onEdit }) => {
  return (
    <span className={styles.carCell}>
      {children}
      {canEdit && <Icon glyph={SvgEdit} className={styles.editIcon} onClick={onEdit} />}
    </span>
  );
};

export default CarAssignmentCell;
